import { useContext } from 'react'

import { FormContext } from '@presentation/contexts'

export const useForm = () => {
  const formContext = useContext(FormContext)

  return formContext
}
